<template>
<div>
    <div v-if="option" class="form-check form-check-inline">
        <input @change="setTypeId()" class="form-check-input" type="radio" name="inlineRadioOptions3" id="inlineRadio3" value="3" v-model="Id">
        <label class="form-check-label" for="inlineRadio3">TUTTO L'ACQUISTATO</label>
    </div>   
    <div class="form-check form-check-inline">
        <input @change="setTypeId()" class="form-check-input" type="radio" name="inlineRadioOptions1" id="inlineRadio1" value="1" v-model="Id">
        <label class="form-check-label" for="inlineRadio1">CARICO DA ORDINE</label>
    </div>
    <div class="form-check form-check-inline">
        <input @change="setTypeId()" class="form-check-input" type="radio" name="inlineRadioOptions2" id="inlineRadio2" value="2" v-model="Id">
        <label class="form-check-label" for="inlineRadio2">RIASSORTIMENTO</label>
    </div>   
       
</div>
</template>
<script>
export default {
  
  props: ['typeId','option'],
 
 data () {
    return {
    
        Id : 1
    }
  },

mounted()
{   
    
   
},
created()
{ 
  this.Id = 1
  if(this.typeId)
  {
    this.Id = this.typeId

  }
  this.setTypeId()
    
},

methods: 
{
    setTypeId()
    {
      
      this.$emit('update',this.Id)
    },
  
      
}
    
}    
</script>

<style scoped>

 .form-check-label
 {
  cursor: pointer;
  font-family: 'Roboto Condensed';
 }

</style>